export default __webpack_public_path__ + "static/media/ocean.052739b7.png";